export default __webpack_public_path__ + "static/media/hht2_ani_14.5445eead.png";